module.exports = __webpack_public_path__ + "static/media/Etir_BandeletteIlioTibiale.d93dfcfa.png";